module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rewardDetails !== null) ? _c('div', [_c('div', {
    staticClass: "reward-name-container"
  }, [_c('h1', {
    staticClass: "u-h1"
  }, [_vm._v(_vm._s(_vm.rewardDetails.name))]), _vm._v(" "), (_vm.hasRange) ? _c('h1', {
    staticClass: "u-h1"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" " + _vm._s(_vm.$t('web.catalog_rewards_filters.filter_from_points')) + " " + _vm._s(_vm.minDefDollarPrice) + " " + _vm._s(_vm.$t('web.catalog_rewards_filters.filter_to_points')) + " " + _vm._s(_vm.maxDefDollarPrice) + " " + _vm._s(_vm.rewardDetails['supplier_items'][0]['currency']))]) : _vm._e()]), _vm._v(" "), (_vm.rewardDetails.images && _vm.rewardDetails.images.length > 0) ? _c('section', {
    staticClass: "c-card c-card--reward-images"
  }, _vm._l((_vm.rewardDetails.images), function(image) {
    return _c('div', {
      staticClass: "c-card--reward-images__slider"
    }, [_c('img', {
      attrs: {
        "src": image.sizes['350x350'],
        "alt": image.description
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--reward-cost"
  }, [_c('div', {
    staticClass: "c-card__body c-card--reward-cost__body"
  }, [_c('div', {
    staticClass: "c-card--reward-cost__points-cost"
  }, [_c('h2', {
    staticClass: "c-card--reward-cost__points-cost__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.points_title')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--reward-cost__points-cost__data qa-points-cost"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" "), (_vm.hasRange) ? _c('span', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_filters.filter_from_points')))]) : _vm._e(), _vm._v(" "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true,
      "value": _vm.hasRange ? _vm.minSalePrice : _vm.salePrice
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-card--reward-cost__points-balance"
  }, [_c('h2', {
    staticClass: "c-card--reward-cost__points-balance__title"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.current_points')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--reward-cost__points-balancedata"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true
    },
    model: {
      value: (_vm.participant.points_balance),
      callback: function($$v) {
        _vm.$set(_vm.participant, "points_balance", $$v)
      },
      expression: "participant.points_balance"
    }
  })], 1)]), _vm._v(" "), (!_vm.participantHasEnoughPoints) ? _c('p', {
    staticClass: "u-paragraph u-center-text qa-insufficient-points"
  }, [_vm._v("\n          " + _vm._s(_vm.getInsufficientPointsMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isSavedReward) ? _c('button', {
    staticClass: "c-button\n                        c-button--full-width\n                        u-margin-bottom-10\n                        t-button-plain\n                        qa-save-for-later-button",
    on: {
      "click": function($event) {
        return _vm.saveForLater()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.save_for_later_button')) + "\n        ")]) : _c('div', {
    staticClass: "c-reward-saved-for-later-button"
  }, [_c('h3', {
    staticClass: "c-reward-saved-for-later-button__title"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.saved_for_later')))]), _vm._v(" "), _c('div', {
    staticClass: "c-reward-saved-for-later-button__links"
  }, [_c('router-link', {
    staticClass: "c-reward-saved-for-later-button__links__link\n                       t-link\n                       qa-view-all-saved",
    attrs: {
      "to": {
        name: 'SavedRewards'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.saved_rewards_link')))]), _vm._v(" "), _c('a', {
    staticClass: "c-reward-saved-for-later-button__links__link\n                        t-link\n                        qa-remove-saved",
    class: {
      'remove-disabled': _vm.deleteProcessing
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_reward.remove_link')))])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--full-width t-button-primary",
    attrs: {
      "disabled": !_vm.participantHasEnoughPoints || _vm.orderProcessing || (!_vm.salePrice > 0 && _vm.minSalePrice <= 0)
    },
    on: {
      "click": function($event) {
        return _vm.orderItem()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_reward.redeem_button')) + "\n        ")])])]), _vm._v(" "), (_vm.rewardDetails.description !== null) ? _c('section', {
    staticClass: "c-card u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.description_title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body",
    domProps: {
      "innerHTML": _vm._s(_vm.formatRewardDetails(_vm.rewardDetails.description))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.rewardDetails.notes !== null) ? _c('section', {
    staticClass: "c-card u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.notes_title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body",
    domProps: {
      "innerHTML": _vm._s(_vm.formatRewardDetails(_vm.rewardDetails.notes))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.orderDetails === null && (_vm.rewardProperties.length > 0 || _vm.rewardVariantProperties.length > 0)) ? _c('section', {
    staticClass: "c-card c-card--reward-properties u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_reward.properties_title')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body c-card--reward-properties__body"
  }, [_vm._l((_vm.rewardVariantProperties), function(variantProperty) {
    return (_vm.rewardVariantProperties.length > 0) ? _c('dl', {
      staticClass: "c-card--reward-properties__dl"
    }, [_c('dt', [_vm._v(_vm._s(variantProperty.name))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(variantProperty.value))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.rewardProperties), function(property) {
    return (_vm.rewardProperties.length > 0) ? _c('dl', {
      staticClass: "c-card--reward-properties__dl"
    }, [_c('dt', [_vm._v(_vm._s(property.name))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(property.value))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.rewardDetails.terms_and_conditions) ? _c('section', {
    staticClass: "c-card u-card-pad-btm"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.account_setup.accept_terms_link')) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "t-link",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleTermsConditions()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.points_record.notes_toggle')) + "\n          "), _c('span', {
    staticClass: "c-points-record__notes__actions__link__icongroup"
  }, [(!_vm.showTermsConditions) ? _c('i', {
    staticClass: "fa fa-chevron-down is-collapsed"
  }) : _vm._e(), _vm._v(" "), (_vm.showTermsConditions) ? _c('i', {
    staticClass: "fa fa-chevron-up is-expanded"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTermsConditions),
      expression: "showTermsConditions"
    }],
    staticClass: "c-card__body",
    domProps: {
      "innerHTML": _vm._s(_vm.formatRewardDetails(_vm.rewardDetails.terms_and_conditions))
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showOrderModal) ? _c('order-modal', {
    on: {
      "close": function($event) {
        return _vm.closeOrderModal()
      },
      "confirm": _vm.confirmOrder
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderConfirmationModal) ? _c('order-confirmation', {
    attrs: {
      "orderConfirmationMessage": _vm.orderConfirmationMessage
    },
    on: {
      "close": function($event) {
        return _vm.closeOrderConfirmationModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderErrorModal) ? _c('order-error', {
    attrs: {
      "orderErrorMessage": _vm.orderErrorMessage
    },
    on: {
      "close": function($event) {
        return _vm.closeOrderErrorModal()
      }
    }
  }) : (_vm.rewardDetails === null) ? _c('loading-icon') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3562ac04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/Reward.vue
// module id = 524
// module chunks = 1